import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3246 2.09043C14.5924 2.25037 14.7238 2.58536 14.6432 2.90225L12.8728 9.85715H19.3333C19.5988 9.85715 19.8389 10.0259 19.9447 10.2868C20.0506 10.5476 20.0018 10.8509 19.8207 11.0588L10.4874 21.7731C10.2782 22.0132 9.94314 22.0695 9.67537 21.9096C9.40761 21.7496 9.27617 21.4146 9.35683 21.0978L11.1272 14.1429H4.66668C4.40122 14.1429 4.16105 13.9741 4.05525 13.7132C3.94945 13.4524 3.99818 13.1491 4.17931 12.9412L13.5126 2.22694C13.7218 1.98681 14.0569 1.93049 14.3246 2.09043ZM6.20082 12.7143H12C12.2078 12.7143 12.4037 12.8181 12.5298 12.995C12.6559 13.1719 12.6978 13.4017 12.6432 13.6165L11.3528 18.6859L17.7992 11.2857H12C11.7922 11.2857 11.5963 11.1819 11.4702 11.005C11.3441 10.8281 11.3022 10.5983 11.3568 10.3835L12.6472 5.31409L6.20082 12.7143Z"
        fill={colorValue}
      />
    </svg>
  );
};
